import apiFetch from '../apiFetch'

export default function (processingAgencyId, token) {
  return apiFetch({ endPoint: 'LogicProcessingAgency/' + processingAgencyId, method: 'DELETE', body: null, token: token })
}
